import store from './store'
import _ from 'lodash'
import InlineHtmlEditor from '@/components/editor/inline/InlineHtmlEditor'
import Vue from 'vue'

export default {
  can: {
    bind: (el, bindings, vnode) => {
      vnode.context.$nextTick(() => {
        let currentUser = store.state.auth.currentUser

        if (
          el.parentElement &&
          currentUser.permissions.indexOf(bindings.value) === -1
        ) {
          el.parentElement.removeChild(el)
        }
      })
    }
  },
  'track-changes-once': {
    bind: (el, bindings, vnode) => {
      let unwatch = vnode.child.$watch('value', () => {
        store.commit('editor/SET_DRAWER_CHANGED', true)

        unwatch()
      })

      store.watch(
        state => state.editor.drawer.changed,
        value => {
          // watch changes on the editor and add onbeforeunload
          if (value) {
            // TODO - enable beforeunload
            // window.onbeforeunload = event => {
            //   event.preventDefault()
            //   event.returnValue = ''
            // }
          } else {
            // TODO - enable beforeunload
            // window.onbeforeunload = null

            // rewatch changes if state.editor.drawer.changed becomes false
            unwatch = vnode.child.$watch('value', () => {
              store.commit('editor/SET_DRAWER_CHANGED', true)

              unwatch()
            })
          }
        }
      )
    }
  },
  'css-watch': {
    bind: (el, bindings, vnode) => {
      Object.keys(bindings.value).forEach(key => {
        vnode.context.$watch(
          () => bindings.value[key],
          newValue => {
            document.documentElement.style.setProperty(`--${key}`, newValue)
          }
        )
      })
    }
  },
  'on-click-outside': {
    bind: function(el, binding, vnode) {
      el.clickOutsideEvent = function(event) {
        if (!(el == event.target || el.contains(event.target))) {
          vnode.context[binding.expression](event)
        }
      }

      document.body.addEventListener('click', el.clickOutsideEvent)
    },
    unbind: function(el) {
      document.body.removeEventListener('click', el.clickOutsideEvent)
    }
  },
  'inline-editable': {
    bind: function(el, binding, vnode) {
      const expressionArray = binding.expression.split('.')
      const tab = expressionArray[1]
      const key = expressionArray[2]

      const enableInline = () => {
        el.classList.add('webble-inline-editor')
        el.setAttribute('contenteditable', true)
        el.addEventListener('input', handleInput, false)
        el.addEventListener('DOMNodeInserted', cleanHTML, false)
      }

      const disableInline = () => {
        el.classList.remove('webble-inline-editor')
        el.setAttribute('contenteditable', false)
        el.removeEventListener('input', handleInput, false)
        el.removeEventListener('DOMNodeInserted', cleanHTML, false)
      }

      const handleInput = () => {
        store.commit('inline/SET_EDITED_SECTIONS', {
          id: vnode.context.section.id,
          tab,
          key,
          value: el.innerHTML
        })
      }

      const cleanHTML = event => {
        // Remove all div and span tags generated
        el.querySelectorAll('span, div').forEach(node => {
          node.replaceWith(...node.childNodes)
        })
      }

      if (
        vnode.context.isLoggedIn &&
        vnode.context.currentUser.mode === 'inline'
      ) {
        enableInline()
      } else {
        disableInline()
      }

      el.innerHTML = binding.value

      // if (binding.modifiers.html) {
      //   const ComponentClass = Vue.extend(InlineHtmlEditor)
      //   const instance = new ComponentClass({
      //     propsData: { html: binding.value }
      //   })
      //   vnode.context[`_inlineEditorInstance${instance._uid}`] = instance
      //   instance.$mount()
      //   el.appendChild(instance.$el)
      //   el.setAttribute('data-inline-editor', instance._uid)
      // }
    },
    update: function(el, binding, vnode) {
      el.innerHTML = binding.value
      //   if (binding.modifiers.html) {
      //     const instanceID = el.getAttribute('data-inline-editor')
      //     vnode.context[
      //       `_inlineEditorInstance${instanceID}`
      //     ].$refs.editableContent.innerHTML = binding.value
      //   }
    }
  }
  // TODO - add history tracking for Undo and Redo options for future versions
  //   'track-history': {
  //     bind: (el, bindings, vnode) => {
  //       vnode.child.$on('logHistory', value => {
  //         console.log(vnode.context)
  //         if (vnode.context.trackHistory) {
  //           store.dispatch('editor/logHistory', {
  //             tab: bindings.value.tab,
  //             index: bindings.value.index,
  //             value
  //           })
  //         }
  //       })
  //     }
  //   }
}
